import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Input } from '@rb/ui'
import { setCurrentUser } from '../lib/auth'
import styles from './Auth.module.css'

export default function Login() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      })
      const data = (await res.json()) as {
        token: string
        user: { id: string; email: string; name: string; role: 'client' | 'admin' | 'super_admin' }
        error?: string
      }
      if (!res.ok) {
        setError(data.error ?? 'Anmeldung fehlgeschlagen')
        return
      }
      setCurrentUser({ ...data.user, name: data.user.name ?? '', token: data.token })
      navigate('/dashboard')
    } catch {
      setError('Verbindungsfehler. Bitte erneut versuchen.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.card}>
      <h1 className={styles.heading}>Anmelden</h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          type="email"
          label="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
        <Input
          type="password"
          label="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        {error && <p className={styles.error}>{error}</p>}
        <Button type="submit" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Wird geladen…' : 'Anmelden'}
        </Button>
      </form>
      <div className={styles.footer}>
        <Link to="/forgot-password" className={styles.link}>
          Passwort vergessen?
        </Link>
      </div>
    </div>
  )
}
